module.exports = __webpack_public_path__ + "9f98a2a692789a506d47bd324b82066c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone-lg.png
// module id = 2011
// module chunks = 0